import type { NftMiniature } from "@anaconda/core/nft/types"
import { createScope } from "bunshi"

export interface PurchasableNft extends NftMiniature {
  price: NonNullable<NftMiniature["price"]>
}

export const NftsToBuyScope = createScope<PurchasableNft[]>([])
